import React from "react";
import { FiTruck, FiAward, FiHeadphones } from "react-icons/fi";

const FeaturesSection = () => {
  return (
    <div className="bg-neutral-950 py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-12 text-center">
        
        {/* Entrega Rápida */}
        <div className="flex flex-col items-center p-4">
          <FiTruck className="w-12 h-12 mb-4 text-neutral-400" />
          <h3 className="text-base font-medium text-white tracking-wide uppercase">
            Entrega Rápida
          </h3>
          <p className="text-sm text-neutral-500 mt-2 leading-relaxed">
            Enviamos para todo o Brasil com rapidez. Na região de Manaus, as entregas costumam ser ainda mais ágeis.
          </p>
        </div>

        {/* Qualidade Garantida */}
        <div className="flex flex-col items-center p-4">
          <FiAward className="w-12 h-12 mb-4 text-neutral-400" />
          <h3 className="text-base font-medium text-white tracking-wide uppercase">
            Qualidade Garantida
          </h3>
          <p className="text-sm text-neutral-500 mt-2 leading-relaxed">
            Nossos smartwatches são selecionados com alto padrão de qualidade, combinando tecnologia, estilo e durabilidade.
          </p>
        </div>

        {/* Suporte Eficiente */}
        <div className="flex flex-col items-center p-4">
          <FiHeadphones className="w-12 h-12 mb-4 text-neutral-400" />
          <h3 className="text-base font-medium text-white tracking-wide uppercase">
            Suporte Eficiente
          </h3>
          <p className="text-sm text-neutral-500 mt-2 leading-relaxed">
            Atendimento rápido e direto via WhatsApp. Tiramos suas dúvidas antes e depois da compra.
          </p>
        </div>
      </div>

      {/* Sobre a Flitz */}
      <div className="max-w-3xl mx-auto mt-20 px-6 text-center">
        <h2 className="text-2xl font-semibold text-white mb-4 tracking-wide">
          Sobre a Flitz
        </h2>
        <p className="text-sm text-neutral-500 leading-relaxed">
          A FlitzStoreBR é uma loja online especializada na venda de smartwatches. Com operação em Manaus-AM e envio para todo o Brasil, oferecemos produtos modernos, ótimo custo-benefício e suporte direto no WhatsApp para garantir sua confiança em cada compra.
        </p>
      </div>
    </div>
  );
};

export default FeaturesSection;